import { render, staticRenderFns } from "./kpi-analysis-unit-selectors.vue?vue&type=template&id=10b8b452&scoped=true"
import script from "./kpi-analysis-unit-selectors.vue?vue&type=script&lang=ts"
export * from "./kpi-analysis-unit-selectors.vue?vue&type=script&lang=ts"
import style0 from "./kpi-analysis-unit-selectors.vue?vue&type=style&index=0&id=10b8b452&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8b452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b8b452')) {
      api.createRecord('10b8b452', component.options)
    } else {
      api.reload('10b8b452', component.options)
    }
    module.hot.accept("./kpi-analysis-unit-selectors.vue?vue&type=template&id=10b8b452&scoped=true", function () {
      api.rerender('10b8b452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/kpi-analysis/selectors/kpi-analysis-unit-selectors.vue"
export default component.exports